import { get } from 'lodash';
import { stringify } from 'query-string';

const resources = {
  users: 'users',
  userBalance: 'users/{id}/billing/balance',
  userHistory: 'users/{filter._id}/billing/history',
  balanceChange: 'users/{id}/billing/balance/{command}',
  shipments: 'shipments',
  shipmentAdjustments: 'shipments/{id}/adjustments',
  shipmentInterception: 'shipments/{id}/intercept',
  shipmentInterceptionCancellation: 'shipments/{shipmentId}/intercept/cancel',
  countries: 'dictionary/countries',
  states: 'dictionary/countries/{countryId}/states',
  enableUser: 'users/enable',
  disableUser: 'users/disable',
  confirmUser: 'users/confirm',
  resetUserPassword: 'users/reset-password',
  massResetUserPassword: 'users/reset-password/job ',
  balanceRefund: 'users/{id}/billing/refund',
  exportDebtor: 'report/debtor/{id}',
  exportDebtors: 'report/debtors',
  exportTopSpenders: 'report/top-spenders',
  exportReportStatus: 'report/status',
  debtors: 'debtors',
  debtorsLoss: 'debtors/loss/{id}',
  pushNotifications: 'push/broadcast',
  debtorsStatuses: 'debtors/statuses',
  bypassFraud: 'fraudsters/bypass',
  updateFraudDetails: 'fraudsters',
  suspendAsFraud: 'fraudsters/block',
  unblockFraud: 'fraudsters/unblock',
  blocklist: 'users/blocklist/phones',
  additionalDocument: `{type}/{id}/documents/{code}`,
  fraudDashboard: `users`,
  sharedWarehouses: `fraudsters/grouped-shared-warehouse-addresses`,
  sharedIpAddresses: `fraudsters/grouped-shared-ip-addresses`,
  sharedFingerprints: `fraudsters/grouped-shared-fingerprints`,
  reviewSharedWarehouse: `fraudsters/review-company-location-presets`,
  reviewSharedIpAddress: `fraudsters/review-ip-address`,
  reviewSharedFingerprint: `fraudsters/review-fingerprint`,
  fraudTypes: `fraudsters/dictionary/fraud-types`,
  userActivity: `audit/list`,
  cloudWatchLogsQuery: `audit/{severity}/query`,
  cloudWatchLogsQueryResult: `audit/{severity}/query/{queryId}`,
  cloudWatchLogsFilter: `audit/{severity}/filter`,
  creditCodes: `credit-codes/campaigns`,
  claims: `claim`,
  userActivityTypes: `audit/dictionary/audit-actions`,
  stripeReceipt: `users/{_id}/billing/receipt`,
  exportUserTransactions: `users/{id}/billing/history/export`,
  exportCreditCodes: `credit-codes/campaigns/{id}/export`,
  claimPhotos: `claim/{id}/photos`,
  claimReceipt: `claim/{id}/receipt`,
  multipleDataUsers: `fraudsters/users-with-multiple-data`,
  updateEmail: `users/email`,
  resetAuthorization: `users/mfa/enable-sms`,
  userKyc: `users/{userId}/kyc`,
  userKycComplete: `users/{userId}/kyc/complete`,
  userKycTimer: `users/{userId}/kyc/timer`,
  blockShipping: `users/block-shipping`,
  blockCardCharging: `users/{userId}/block-charging`,
  smallPackagesAllow: `users/{userId}/small-packages`,
  spendingLimits: `users/{userId}/budget`,
  refundAllBalance: `users/{userId}/billing/refund-all`,
  bulkRefund: `users/{userId}/billing/refunds`,
  userDetails: `users/{userId}/{billingUserId}/{currency}/summary`,
  membersList: `users/{filter._id}/members`,
  enableOrDisableMember: `users/{tenantId}/members/{memberId}/{action}`,
  deleteOrEditMember: `users/{tenantId}/members/{memberId}`,
  membersRoles: `users/{tenantId}/members/roles`,
  createMember: `users/{tenantId}/members`,
  billingFees: `users/{id}/billing/payment-fees`,
  sharedDataUsersDetails: `fraudsters/details`,
  rewardsLevel: `rewards/levels`,
  rewardsPerk: `rewards/perks`,
  rewardsBadge: `rewards/badges`,
  rewardsUpdatePerkLevels: `rewards/levels/{levelId}/perks/{benefitId}`,
  rewardsPerkSystemTypes: `rewards/perks/system-types`,
  rewardsAction: `rewards/actions`,
  rewardsActionSystemTypes: `rewards/actions/system-types`,
  rewardsActionCtaIds: `rewards/actions/cta-ids`,
  rewardsVerificationList: `rewards/actions/verifications`,
  rewardsUpdateVerificationStatus: `rewards/actions/verifications/{id}/status`,
  rewardsBulkUpdateVerificationStatus: `rewards/actions/verifications/status`,
  achTiers: `v1/ach-tiers`,
  releaseTierFromHold: `users/{userId}/billing/ach/release-ach-tier-hold`,
  updatePaymentOptions: `users/{userId}/billing/payment-options`,
  updateUserRiskTier: `ach-risk-profiles/risk-tier`,
  userRiskProfile: `ach-risk-profiles`,
  expeditedShipments: `users/{userId}/expedited-shipments`,
  cancelAchTransaction: `users/{userId}/billing/ach/cancel-payment`,
};

const getResource = (resource, params: any = null, isExternal?) => {
  if (isExternal) {
    return params?.data || params?.filter ? stringify(params?.data || params?.filter) : '';
  }

  return resources[resource]
    ? params
      ? resources[resource].replace(
          /{([\w.]+)}/g,
          (match, key) => get(params, key) || params.data[key]
        )
      : resources[resource]
    : resource;
};

export default getResource;
